import React from "react";
import FloatingMenu from "../FloatingMenu";
import { Container } from "./styles";

export default ({ x, y, width, height, addGeneratedCard, addImageCard, showMenu, zoom }) => {
  return (
    <Container
      style={{
        left: x,
        top: y,
        width: width,
        height: height,
      }}
    >
      {showMenu && (
        <FloatingMenu
          addGenerated={addGeneratedCard}
          addImage={addImageCard}
          zoom={zoom}
        />
      )}
    </Container>
  );
};
